function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.887-.032a.982.982,0,0,0-.106.026.846.846,0,0,0-.66.845v.9a9.286,9.286,0,0,0-8.389,8.393H.758a.845.845,0,0,0,.079,1.689h.9a9.286,9.286,0,0,0,8.389,8.393v.9a.844.844,0,1,0,1.688,0v-.9A9.286,9.286,0,0,0,20.2,11.818h.9a.845.845,0,1,0,0-1.689h-.9a9.286,9.286,0,0,0-8.389-8.393v-.9a.845.845,0,0,0-.923-.871Zm-.765,4.3v.792a.844.844,0,1,0,1.688,0V4.27a6.743,6.743,0,0,1,5.856,5.859H16.8a.845.845,0,0,0,.079,1.689h.791a6.743,6.743,0,0,1-5.856,5.859v-.792a.844.844,0,1,0-1.688,0v.792a6.743,6.743,0,0,1-5.856-5.859h.791a.845.845,0,1,0,0-1.689H4.266A6.743,6.743,0,0,1,10.122,4.27Z",
  transform: "translate(0.048 0.036)"
});

var SvgLocationIcon = function SvgLocationIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location-icon.948b91fd.svg";
export { ForwardRef as ReactComponent };